<template>
    <div class="tabs">
      <div :class="{top1:top1 === 1}" @click="goList('standings')">{{ $t('match.homeTabs.text_1') }}</div>
      <div :class="{top1:top1 === 2}" @click="goList('MatchSchedule')">{{ $t('match.homeTabs.text_2') }}</div>
      <div :class="{top1:top1 === 3}" @click="goList('player-list')" v-if="sportType === '足球' || sportType === '篮球' || sportType === '橄榄球'">{{ $t('match.homeTabs.text_4') }}</div>
      <div :class="{top1:top1 === 4}" @click="goList('team-list')" v-if="sportType === '橄榄球'">{{ $t('match.homeTabs.text_3') }}</div>
    </div>
</template>

<script>
export default {
  props: {
    top1: Number,
    matchId: String,
    sportType: String
  },
  name: 'MatchTabs',
  methods: {
    goList(path) {
      this.$router.push({ path, query: { matchId: this.matchId }})
    }
  }
}
</script>

<style scoped lang="scss">
.tabs{
  font-size: 14px;
  color: #333;
  display: flex;
  border-bottom: 1px solid #f0f0f0;
  div{
    flex: 1;
    text-align: center;
    padding: 10px 0;
  }
  .top1{
    border-bottom: 1px solid #cc3232;
  }
}
</style>
